export const VERIFIED = 1;
export const EDIT = 2;
export const LOADING = 0;
